import { queryClient } from "~/backend/queryClient"
import { findIngestionsQueryKey, useRevertImport } from "~/gen/api"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useRevertImportMutation = () =>
  useRevertImport({
    mutation: {
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: findIngestionsQueryKey({ sorts: {}, filters: {} }),
        })
        showSuccessNotification({
          title: "Success",
          message: "Ingestion reverted",
        })
      },
      onError: (error) => {
        showAxiosError({
          notificationTitle: "Error",
          notificationMessage: error.message,
          showNotification: true,
          error,
        })
      },
    },
  })
